import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28ac8364"
import script from "./addEditReProvision.js?vue&type=script&lang=js&external"
export * from "./addEditReProvision.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports